import {
    autoFit,
    autoSizeColumns,
    autoSizeRows,
    Column,
    DivRenderer,
    flattenArrayWithObj,
    Row,
} from '../../experimental.grid';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const willMeasure = (node) => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (node.renderContext && node.renderContext.element) {
        node.renderContext.element.classList.add('sc-grid-table--measure');
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const didMeasure = (node) => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (node.renderContext && node.renderContext.element) {
        node.renderContext.element.classList.remove('sc-grid-table--measure');
    }
};

export function addColumnsMeasure(columns: Column[]): void {
    const cols = columns && flattenArrayWithObj(columns, 'children');
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    cols &&
        cols.forEach((e) => {
            e.willMeasure = willMeasure;
            e.didMeasure = didMeasure;
        });
}

export function addRowsMeasure(rows: Row[]): void {
    if (rows && rows.length > 0) {
        rows.forEach((r) =>
            r.cells.forEach((l) => {
                l.willMeasure = willMeasure;
                l.didMeasure = didMeasure;
            }),
        );
    }
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function autoFit1(renderer: DivRenderer): any {
    const containerWidth: number =
        renderer.gridNode.renderContext.element.parentElement.getBoundingClientRect()
            .width;
    let gridWidth: number = renderer.opts.columns
        .filter((a) => !a.hidden)
        .map((a) => a.width)
        .reduce(function (a, b) {
            return a + b;
        });

    let hasChildColumns: boolean = false;
    if (isNaN(gridWidth)) {
        gridWidth = 0;
        renderer.opts.columns
            .filter((a) => !a.hidden)
            .forEach((_column) => {
                _column.children
                    .filter((a) => !a.hidden)
                    .forEach((_childColumn) => {
                        gridWidth += _childColumn.width;
                    });
            });
        hasChildColumns = true;
    }

    const emptySpace = containerWidth - gridWidth;
    if (gridWidth < containerWidth) {
        if (hasChildColumns) {
            renderer.opts.columns.forEach((_column) => {
                _column.children
                    .filter((a) => !a.hidden)
                    .forEach((_childColumn) => {
                        _setNewWidth(
                            renderer,
                            _childColumn,
                            gridWidth,
                            emptySpace,
                        );
                    });
            });
        } else {
            renderer.opts.columns
                .filter((a) => !a.hidden)
                .forEach((_column) => {
                    _setNewWidth(renderer, _column, gridWidth, emptySpace);
                });
        }
    }
    return renderer;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function _setNewWidth(renderer, column, gridWidth, emptySpace) {
    const _ratio = column.width / gridWidth;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const _newWidth: number = column.width + emptySpace * _ratio;
    renderer.setColumnWidth(column.id, _newWidth);
}

// eslint-disable-next-line @typescript-eslint/promise-function-async
export function autoSizeGrid(
    renderer: DivRenderer,
    left: Column[],
    right: Column[],
    element?: HTMLElement,
): Promise<void> {
    return (
        autoSizeColumns(right, renderer, true)
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            .then(() => autoSizeColumns(left, renderer))
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            .then(() => autoFit(renderer, element))
            // last row of the column rows. autoSizeRows() will check for sticky left/right column rows
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            .then(() =>
                autoSizeRows(
                    [...renderer.contentColumns.columns.children].reverse(),
                    renderer,
                    [...left, ...right],
                    {},
                ),
            )
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            .then(() => renderer.layout())
            .catch((err) => CMPS_APP_DEF.ENV !== 'prod' && console.warn(err))
    );
}
